'use strict';

require("../_assets/fonts-CoIbUPG2.css");
//# sourceMappingURL=fonts-CZ0t0x6L.js.map
